//hamburger
const toggleGlobalNav = () => {

  const hamburger = document.getElementById('js-hamburger');

  if (!hamburger) return;

  const body = document.body;

  hamburger.addEventListener('click', () => {
    body.classList.toggle('is-gnav-active');
  });
}
toggleGlobalNav();

